import React, { createContext, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import SearchForm from './SearchForm';
import SearchResults from './SearchResults';
import { searchPublisher } from '../../features/publisherApi';
import ReactPaginate from 'react-paginate';

export const PublisherSearchContext = createContext();

const PublisherSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [publishers, setPublishers] = useState([]);
  const [pageCount, setPageCount] = useState([]);
  const [page, setPage] = useState(0);

  const searchPublishers = () => {
    searchPublisher(searchTerm, page + 1).then(({publishers, pages}) => {
      setPublishers(publishers);
      setPageCount(pages);
    });
  }

  const handlePageClick = (e) => {
    setPage(e.selected);
  }

  useEffect(() => {
    searchPublishers();
  }, [page]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(0);
      searchPublishers();
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm])
  
  return (
    <>
      <SearchForm setSearchTerm={setSearchTerm}/>
      <SearchResults publishers={publishers}/>
      <ReactPaginate
        className="react-paginate"
        breakLabel="..."
        nextLabel="Next"
        onPageChange={handlePageClick}
        forcePage={page}
        pageRangeDisplayed={5}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        previousLabel="Previous"
        pageLinkClassName="btn btn-thin btn-purple"
        previousLinkClassName="btn btn-thin btn-purple"
        nextLinkClassName="btn btn-thin btn-purple"
        breakLinkClassName="btn btn-thin btn-purple"
        disabledLinkClassName="disabled"
      />
    </>
  );
};

export default PublisherSearch;

// Bind react component to all occurences of html tag with id ReportModal
$('#PublisherSearch').each(function () {
  createRoot(this).render(
    React.createElement(PublisherSearch)
  );
});